import React from "react";

import { Stack } from "@mui/material";
import { Color } from "Components/Form/Button";
import Modal, { ModalType } from "Components/Generic/Modal";
import { NotificationToast } from "Components/Generic/Toast/NotificationToast";
import { useCustomerPortalContext } from "Context/CustomerPortalContext";
import { useCustomerPortalJobContext } from "Context/CustomerPortalJobContext";
import { useTranslation } from "react-i18next";

import useStyles from "./styles";

interface Props {
  open?: boolean;
  onClose?: () => void;
}

const RemoveEscalationModal = (props: Props) => {
  const { open = false, onClose } = props;

  const { onRequestEscalation, isRequestingEscalation } = useCustomerPortalContext();
  const { order } = useCustomerPortalJobContext();

  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <Modal
      open={open}
      className={classes.modal}
      handleClose={isRequestingEscalation ? undefined : () => onClose && onClose()}
      title={translate("removeEscalationRequest")}
      showActionButtons
      type={ModalType.WARNING}
      actionButtonProps={{
        onCancel: onClose,
        onSave: () => {
          if (order?.id)
            onRequestEscalation(
              { jobId: order?.id },
              () => {
                NotificationToast.info(translate("escalationRequestHasBeenRemoved"));
                if (onClose) onClose();
              },
              () => {
                NotificationToast.error(`${translate("ohNoSomethingWentWrongPleaseTryAgain")}.`);
              }
            );
        },
        customColorSave: Color.WARNING,
        customColorCancel: Color.DARK,
        textCancel: translate("noKeepIt"),
        textSave: translate("remove"),
        loading: isRequestingEscalation,
        cancelDisabled: isRequestingEscalation,
      }}
    >
      <Stack width="100%" direction="column" spacing={1}>
        <span className={classes.textRelinkModal}>
          {translate("removingThisEscalationChangeRequestWillClearAnyPendingRequests")}.{" "}
          <b>{translate("areYouSureYouWishToProceed")}?</b>
        </span>
      </Stack>
    </Modal>
  );
};

export default RemoveEscalationModal;
